import type { RouteRecordRaw } from 'vue-router'
import { routeNames, routePaths } from '@/router/router-constants'

export const subjectTypeRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.subjectTypes,
    name: routeNames.subjectTypes,
    component: () => import('@/pages/subject-types/SubjectTypesView.vue'),
    meta: {
      permission: 'subject-types.read.all',
      labelKey: 'subjectTypes',
      icon: 'material-symbols-outlined',
      iconText: 'manage_accounts',
    },
  },
  {
    path: routePaths.subjectTypeDetails,
    name: routeNames.subjectTypeDetails,
    component: () => import('@/pages/subject-types/SubjectTypeDetailsView.vue'),
    meta: {
      permission: 'subject-types.read.all',
      rootRouteName: routeNames.subjectTypes,
    },
  },
  {
    path: routePaths.subjectTypeCreation,
    name: routeNames.subjectTypeCreation,
    component: () => import('@/pages/subject-types/AddEditSubjectTypeView.vue'),
    meta: {
      permission: 'subject-types.write.all',
      labelKey: 'new_m',
      rootRouteName: routeNames.subjectTypes,
    },
  },
  {
    path: routePaths.subjectTypeEdit,
    name: routeNames.subjectTypeEdit,
    component: () => import('@/pages/subject-types/AddEditSubjectTypeView.vue'),
    meta: {
      permission: 'subject-types.write.all',
      labelKey: 'edit',
      rootRouteName: routeNames.subjectTypes,
    },
  },
]
